function vzGetCurrentUrlWithoutHash() {
  if (!window.vzSmoothScrollPageUrl) {
    window.vzSmoothScrollPageUrl = window.location.href.split('#')[0];
  }

  return window.vzSmoothScrollPageUrl;
}

function vzDecodeHash(hash) {
  try {
    return decodeURIComponent(hash);
  } catch (e) {
    return hash;
  }
}

function vzGetAnchorUrl(targetId) {
  const url = new URL(vzGetCurrentUrlWithoutHash());
  url.hash = targetId;

  return url.href;
}

function vzSmoothScrollInit() {
  if (window.vzSmoothScrollInitialized) {
    return;
  }

  window.vzSmoothScrollInitialized = true;
  const pageUrl = new URL(vzGetCurrentUrlWithoutHash());

  document.addEventListener('click', function(event) {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    const link = event.target.closest('a[data-smooth-scroll]');
    if (!link) {
      return;
    }

    const href = link.getAttribute('href');
    if (!href || href === '#') {
      return;
    }

    let samePage = false;
    let targetId = '';

    if (href.charAt(0) === '#') {
      samePage = true;
      targetId = href.substring(1);
    } else {
      let url;

      try {
        url = new URL(href, window.location.href);
      } catch (e) {
        return;
      }

      samePage = (
        url.origin === pageUrl.origin &&
        url.pathname === pageUrl.pathname &&
        url.search === pageUrl.search
      );

      if (!samePage || !url.hash) {
        return;
      }

      targetId = url.hash.substring(1);
    }

    const target = document.getElementById(vzDecodeHash(targetId));
    if (!target) {
      return;
    }

    event.preventDefault();

    const offset = parseInt(link.dataset.offset, 10) || 0;
    const top = target.getBoundingClientRect().top + window.pageYOffset - offset;

    try {
      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    } catch (e) {
      window.scrollTo(0, top);
    }

    if (history.pushState) {
      history.pushState(null, '', vzGetAnchorUrl(target.id));
    } else {
      window.location.hash = target.id;
    }
  });
}
